import styled from "styled-components";

export const MyWorkWrapper = styled.div`
    display: grid;
    background-color: red
    `;

